var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container flex flex-column items-center"},[_c('div',{staticClass:"ove-container flex flex-column items-center",staticStyle:{"margin-top":"50px"}},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.articeVO.content)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f787c676","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/article/OtherArticle.vue
// module id = null
// module chunks = 